import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../core/services/toastNotif.service';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { ParkingCardInfo } from '../../../../core/models/information.model';
import {
  MyVehicleAllResponse,
  MyVehicleAllForChange,
} from '../../../../core/models/user.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QRCodeComponent } from 'angularx-qrcode';
import { PssLoadingComponent } from '../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ToastWarnComponent } from '../../../../tools/template/toast/toast-warn/toast-warn.component';
import { ToastFailedComponent } from '../../../../tools/template/toast/toast-failed/toast-failed.component';
import { ToastSuccessComponent } from '../../../../tools/template/toast/toast-success/toast-success.component';
import { ToastCustomService } from '../../../../tools/services/toast/toast-custom/toastCustom.service';
import { SettingMycardModalComponent } from '../../modals/services-category/my-member-card/my-vehicle-select/setting-mycard-modal/setting-mycard-modal.component';
import { CorrectLicenseCardsPayload } from '../../../../core/models/parking_card/parkingCard.model';
import { ApiVehicleService } from '../../../../core/services/api/Vehicle/api-vehicle';
import { ApiParkingService } from '../../../../core/services/api/Parking/api-parking';
import { ApiLicenseService } from '../../../../core/services/api/Vehicle/api-license';

@Component({
  selector: 'app-my-member-card-2',
  imports: [
    CommonModule,
    FormsModule,
    QRCodeComponent,
    PssLoadingComponent,
    SettingMycardModalComponent,
  ],
  templateUrl: './my-member-card-2.component.html',
  styleUrl: './my-member-card-2.component.css',
})
export class MyMemberCard2Component {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;

  token: string = '';
  uid: string = '';
  myCards: ParkingCardInfo[] = [];
  filteredMyCards: ParkingCardInfo[] | null = null;
  isOpenFilterCategory: boolean = false;
  filterCategory: { value: string; labelTH: string; labelEN: string }[] = [
    { value: 'cardName', labelTH: 'หมายเลขบัตร', labelEN: 'Card Number' },
    { value: 'vehicleType', labelTH: 'ประเภทรถ', labelEN: 'Vehicle Type' },
    { value: 'siteName', labelTH: 'สถานที่', labelEN: 'Location' },
  ];
  selectedCategory: string = 'cardName';
  searchText: string = '';

  isLoading: boolean = true;
  obfuscatedCode: string = '';
  showModal_option: boolean = false;
  isModalOpen = false;
  selectedLicensePlate: string = '';
  isModalLicenseOpen = false;
  selectedCard: ParkingCardInfo | null = null;
  licensePlates: MyVehicleAllResponse[] = [];

  qrValue: string = 'https://example.com/mydata';

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false;
  textWarn: string = '';
  detailWarn: string = '';
  isError: boolean = false;
  textError: string = '';
  detailError: string = '';

  isManageModalOpen = false;

  constructor(
    private cookieService: CookieService,
    private apiVehicleService: ApiVehicleService,
    private apiParkingService: ApiParkingService,
    private apiLicenseService: ApiLicenseService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private languageService: LanguageService,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getMyMemberCard();
    }, 200);
  }
  // ================= Normal Functions =================

  // KPI Count Getters
  get totalCardsCount(): number {
    return this.myCards?.length || 0;
  }

  get activeCardsCount(): number {
    return this.myCards?.filter(card => card.isActive && !this.isExpired(card.expireDate)).length || 0;
  }

  get expiredCardsCount(): number {
    return this.myCards?.filter(card => !card.isActive || this.isExpired(card.expireDate)).length || 0;
  }

  getCardGradient(index: number): string {
    const gradients = [
      'from-blue-400 to-sky-500',      // Blue
      'from-rose-400 to-pink-500',     // Pink/Red
      'from-purple-400 to-indigo-500', // Purple
      'from-amber-400 to-orange-500',  // Orange
      'from-emerald-400 to-teal-500',  // Green
    ];
    return gradients[index % gradients.length];
  }

  isExpired(expireDateStr: string): boolean {
    if (!expireDateStr) return true;
    return new Date(expireDateStr) < new Date();
  }

  isExpiringSoon(expireDateStr: string): boolean {
    if (!expireDateStr) return false;
    const exp = new Date(expireDateStr);
    const now = new Date();
    const diffTime = exp.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 7;
  }

  copyToClipboard(text: string) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      this.toastCustomService.showSuccess(
        this.currentLang === 'TH' ? 'คัดลอกสำเร็จ' : 'Copied Successfully',
        this.currentLang === 'TH' ? 'คัดลอกหมายเลขบัตรแล้ว' : 'Card number copied to clipboard'
      );
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  /* ---------------------------------------- Function ------------------------------------ */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text);
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text);
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text);
  }

  /* --- Function --- */
  goback() {
    this.router.navigate(['/home']);
  }
  getMyMemberCard() {
    this.apiParkingService.getParkingCardInfo(this.token, this.uid).subscribe({
      next: (cards: ParkingCardInfo[]) => {
        console.log('getParkingCardInfo', cards);
        this.myCards = cards;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        this.isLoading = false;
      },
    });
  }

  openListLicense(card: ParkingCardInfo) {
    this.selectedCard = card;
    if (this.selectedCard) {
      this.showModal_option = false;
      this.getUserVehicleAllByCardCode();
    } else {
      console.log(' No Card');
    }
  }

  openModal(license: string) {
    // console.log('select QR', this.selectedCard);
    // เวลาปัจจุบัน + 10 นาที
    const now = new Date();
    now.setMinutes(now.getMinutes() + 10);
    // แปลงเป็นรูปแบบ yymmddHHmm เช่น 2505011259 (คุณใช้ '250501125959' ก็ได้ถ้าอยากใส่วินาที)
    const yyMMddHHmmss = this.formatDateForKey(now);
    // รวม UUID|datetime แล้ว obfuscate
    const raw = `${this.selectedCard?.cardCode}|${yyMMddHHmmss}`;
    this.obfuscatedCode = this.obfuscate(raw) + '$' + license;
    // console.log('Enceipt', this.obfuscatedCode);
    // console.log('Deceipt', this.deobfuscate(this.obfuscatedCode));
    this.isModalOpen = true;
    this.showModal_option = false;
  }

  deobfuscate(input: string): string {
    // ลบอักขระสุ่มที่ใช้ในการ obfuscate
    const cleaned = input.replace(/[XYZ]/g, '');

    // แยก reversedDate|reversedUuid
    const parts = cleaned.split('|');
    if (parts.length !== 2) return input;

    const reversedDate = parts[0];
    const reversedUuid = parts[1];

    // กลับด้านกลับมาเป็นของเดิม
    const datetime = reversedDate.split('').reverse().join('');
    const uuid = reversedUuid.split('').reverse().join('');

    return `${uuid}|${datetime}`;
  }

  openRenewal(card: ParkingCardInfo) {
    this.selectedCard = card;
    // console.log('select QR', this.selectedCard);
    this.showModal_option = false;
    setTimeout(() => {
      sessionStorage.setItem(
        'providerId',
        this.selectedCard?.siteId.toString() ?? '0',
      );
      sessionStorage.setItem(
        'providerName',
        this.selectedCard?.siteName ?? '-',
      );
      this.router.navigate(['/register-member-vehicle'], {
        state: {
          myData: 1,
          vehicleId: this.selectedCard?.id,
          expire_date: this.selectedCard?.expireDate,
          vehicleType: this.selectedCard?.vehicleType,
          card_code: this.selectedCard?.cardCode,
          windowState: 'ต่ออายุ',
        },
      });
    }, 0);
  }

  openManageCard(card: ParkingCardInfo) {
    this.selectedCard = card;
    console.log('manage card', card);
    this.isManageModalOpen = true;
  }

  closeManageCard() {
    this.isManageModalOpen = false;
  }

  //when user select new vehicle for edit
  onRequestChangePlate(event: {
    card: ParkingCardInfo;
    selectedVehicle: MyVehicleAllForChange;
  }) {
    this.isManageModalOpen = false;
    console.log('onRequestChangePlate', event);

    const payload: CorrectLicenseCardsPayload = {
      cardId: event.card.id,
      siteId: event.card.siteId,
      plateNumber: event.selectedVehicle.plate_number,
      province: event.selectedVehicle.province_name,
      uid: this.uid,
    };

    this.isLoading = true;
    this.apiLicenseService.postCorrectLicenseCards(this.token, payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status === 'Succeed') {
          this.showSuccess(
            this.currentLang === 'TH'
              ? 'แก้ไขทะเบียนเรียบร้อย'
              : 'License Plate Changed',
          );
          this.getMyMemberCard();
        } else {
          this.showError(res.message || 'Error occurred');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Failed to correct license card', err);
        this.showError(
          this.currentLang === 'TH'
            ? 'เกิดข้อผิดพลาดในการแก้ไขทะเบียน'
            : 'Error occurred while changing license plate',
        );
      },
    });
  }

  formatDateForKey(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return (
      pad(date.getFullYear() % 100) + // yy
      pad(date.getMonth() + 1) + // MM
      pad(date.getDate()) + // dd
      pad(date.getHours()) + // HH
      pad(date.getMinutes()) + // mm
      pad(date.getSeconds())
    );
  }

  getUserVehicleAllByCardCode() {
    this.licensePlates = [];
    this.apiVehicleService
      .getVehicleMemberInfo(
        this.token,
        this.uid,
        this.selectedCard?.siteId || 0,
        this.selectedCard?.cardCode || '',
      )
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          console.log("Get Vehicle By Card Code", response);

          response.forEach((vehicle) => {
            this.licensePlates.push(vehicle);
          });
          /* ---- ถ้าทะเบียนมากกว่า 1 จะเปิด modal --- */
          if (this.licensePlates.length > 1) {
            this.isModalLicenseOpen = true;
          } else {
            this.isModalLicenseOpen = false;
            this.selectPlate(this.licensePlates[0]);
          }
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  goHome() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }

  closeModal() {
    this.selectedCard = null;
    this.isModalOpen = false;
    this.showModal_option = false;
  }

  obfuscate(input: string): string {
    console.log('obfuscate', input);
    const junkChars = ['X', 'Y', 'Z'];
    const parts = input.split('|');
    if (parts.length !== 2) return input;

    const uuid = parts[0];
    const datetime = parts[1];

    const reversedUuid = uuid.split('').reverse().join('');
    const reversedDate = datetime.split('').reverse().join('');

    const merged = `${reversedDate}|${reversedUuid}`;

    let result = '';
    for (let i = 0; i < merged.length; i++) {
      result += merged[i];
      if ((i + 1) % 4 === 0) {
        const randomChar =
          junkChars[Math.floor(Math.random() * junkChars.length)];
        result += randomChar;
      }
    }

    return result;
  }

  isBase64Image(data: string): boolean {
    if (!data) return false;
    const str = data.trim();
    return str.startsWith('data:image/') || str.startsWith('iVBORw0KGgo') || str.startsWith('/9j/');
  }

  getQrImageSrc(data: string): string {
    if (!data) return '';
    const str = data.trim();
    if (str.startsWith('data:image/')) return str;
    if (str.startsWith('iVBORw0KGgo')) return `data:image/png;base64,${str}`;
    if (str.startsWith('/9j/')) return `data:image/jpeg;base64,${str}`;
    return str;
  }

  closeModal_option() {
    this.showModal_option = false;
  }

  openModal_option(card: ParkingCardInfo) {
    this.selectedCard = card;
    console.log("Select Card : ", this.selectedCard);
    this.showModal_option = true;
  }

  selectPlate(text: MyVehicleAllResponse) {
    // console.log(text);
    this.selectedLicensePlate = text.plate_number;
    console.log(this.selectedLicensePlate);
    this.isModalLicenseOpen = false;
    this.openModal(this.selectedLicensePlate);
  }

  /* ------ Search card ------ */
  searchCards() {
    if (this.searchText === '') {
      this.filteredMyCards = null;
      return;
    }
    switch (this.selectedCategory) {
      case 'cardName':
        this.filteredMyCards = this.myCards.filter((card) => {
          return card.cardName
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
        break;
      case 'siteName':
        this.filteredMyCards = this.myCards.filter((card) => {
          return card.siteName
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
        break;
      case 'vehicleType':
        this.filteredMyCards = this.myCards.filter((card) => {
          return card.vehicleType
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
        break;
    }
    //console.log("searchText", this.searchText , this.filteredMyCards);
  }
  filterByCategory(category: string) {
    this.selectedCategory = category;
    switch (category) {
      case 'cardName':
        this.filteredMyCards = this.myCards.filter((card) => {
          return card[category]
            .toLowerCase()
            .includes(this.searchText.toLowerCase());
        });
        break;
      case 'siteName':
        this.filteredMyCards = this.myCards
          .filter((card) =>
            card[category]
              ?.toLowerCase()
              .includes(this.searchText.toLowerCase()),
          )
          .sort((a, b) =>
            a[category].localeCompare(
              b[category],
              this.currentLang === 'TH' ? 'th' : 'en',
            ),
          ); // ✅ เรียงตามตัวอักษร
        break;
      case 'vehicleType':
        this.filteredMyCards = this.myCards
          .filter((card) =>
            card[category]
              ?.toLowerCase()
              .includes(this.searchText.toLowerCase()),
          )
          .sort((a, b) =>
            a[category].localeCompare(
              b[category],
              this.currentLang === 'TH' ? 'th' : 'en',
            ),
          ); // ✅ เรียงตามตัวอักษร
        break;
    }
    console.log('filterCategory', this.searchText, this.filteredMyCards);
  }
  clearSearch() {
    this.searchText = '';
    this.filteredMyCards = null;
  }
}
